
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M440 216a48 48 0 00-48-48c-.706 0-1.406.023-2.1.053a44.012 44.012 0 00-42.615-71.186C329.622 53.447 295.367 24 256 24c-36.855 0-69.231 25.808-87.7 64.729a47.994 47.994 0 00-43.883 79.481 48.777 48.777 0 00-4.414-.21 47.99 47.99 0 00-29.844 85.58 80.018 80.018 0 00112.356 90.609 71.982 71.982 0 00106.976 0 79.993 79.993 0 00112.353-90.609A47.9 47.9 0 00440 216z","fill":"#35a872"}}),_c('path',{attrs:{"d":"M280 312l64-96h-48l-40 64-40-64h-48l64 96v136c0 32.052-24 40-24 40h96s-24-7.948-24-40z","fill":"#95573a"}})])
          )
        }
      }
    